import React from 'react';

function WritingSettingsTab({ fontSize, pomodoroMinutes, onFontSizeSelect, onPomodoroSelect }) {
  return (
    <div className="pf-writing-settings">
      <div className="pf-row">
        <span className="pf-label">Font Size</span>
        <div className="pf-fontsize-bar" role="group" aria-label="Font size">
          {['small', 'medium', 'large'].map((size) => (
            <button
              key={size}
              type="button"
              className={`pf-fontsize-btn ${fontSize === size ? 'active' : ''}`}
              onClick={() => onFontSizeSelect(size)}
              aria-pressed={fontSize === size}
            >
              {size.charAt(0).toUpperCase() + size.slice(1)}
            </button>
          ))}
        </div>
      </div>

      <div className="pf-row">
        <span className="pf-label">Pomodoro Length</span>
        <div className="pf-fontsize-bar" role="group" aria-label="Pomodoro session length">
          {[15, 25, 45, 60].map((mins) => (
            <button
              key={mins}
              type="button"
              className={`pf-fontsize-btn ${pomodoroMinutes === mins ? 'active' : ''}`}
              onClick={() => onPomodoroSelect(mins)}
              aria-pressed={pomodoroMinutes === mins}
            >
              {mins} min
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

export default WritingSettingsTab;
